import request from '@/utils/request'

//依据字典编码查询字典项
export function listItemByCode(code){
    return request({
        url: '/dict-item/listByDictCode',
        method: 'get',
        params: {code: code}
    })
}

//依据编码与值提取对应说明
export function getTitleByCodeAndValue(code, value){
    return request({
        url: '/dict-item/getByCodeAndValue',
        method: 'get',
        params: {code: code, value: value}
    })
}

//依据编码与值提 验证是否存在，不存在添加
export function setTitleByCodeAndTitle(code, Title){
    return request({
        url: '/dict-item/setTitleByCodeAndTitle',
        method: 'get',
        params: {code: code, title: Title}
    })
}